const isBrowserEnv = () =>
  typeof window === `object` && typeof window.document === `object`;

export default isBrowserEnv;
